(() => {
  if (customElements.get('location-stock')) return;
  const query = 'query LocationStock($ids:[ID!]!){nodes(ids:$ids){... on ProductVariant{id storeAvailability(first:20){nodes{quantityAvailable location{id name}}pageInfo{hasNextPage endCursor}}}}}';
  class LocationStock extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.config = JSON.parse(this.querySelector('[data-stock-config]').textContent);
      this.text = JSON.parse(this.querySelector('[data-stock-text]').textContent);
      this.memberIds = [...new Set(JSON.parse(this.querySelector('[data-stock-members]')?.textContent || JSON.stringify([this.dataset.variantId])))].map(id => 'gid://shopify/ProductVariant/' + String(id).split('/').pop());
      this.basis = JSON.parse(this.querySelector('[data-stock-basis]')?.textContent || 'null');
      this.refresh = () => { if (!document.hidden) this.load(); };
      document.addEventListener('visibilitychange', this.refresh);
      window.addEventListener('online', this.refresh);
      this.load();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      document.removeEventListener('visibilitychange', this.refresh);
      window.removeEventListener('online', this.refresh);
    }
    renderUnknown() {
      this.querySelector('[data-stock-summary]').textContent = this.dataset.canOrder === 'true' ? this.text.orderableUnknown : this.text.unavailable;
      this.querySelectorAll('[data-location-id]').forEach((row) => {
        row.dataset.state = 'unknown';
        row.querySelector('[data-stock-status]').textContent = this.text.unknown;
      });
    }
    async load() {
      this.controller?.abort();
      this.controller = new AbortController();
      const controller = this.controller;
      const list = this.querySelector('dl');
      list.setAttribute('aria-busy', 'true');
      if (this.dataset.tracked !== 'true') {
        this.renderUnknown();
        list.setAttribute('aria-busy', 'false');
        return;
      }
      const timeout = setTimeout(() => controller.abort(), 10000);
      try {
        const response = await fetch(`https://${this.config.domain}/api/${this.config.version}/graphql.json`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': this.config.publicToken },
          body: JSON.stringify({ query, variables: { ids: this.memberIds } }),
          signal: controller.signal
        });
        if (!response.ok) throw new Error('Stock lookup failed');
        const result = await response.json();
        const nodes = result.data?.nodes;
        if (result.errors?.length || !nodes || nodes.every(node => !node)) throw new Error('Stock data unavailable');
        if (nodes.some(node => node?.storeAvailability?.pageInfo.hasNextPage)) throw new Error('Incomplete stock data');
        if (!this.isConnected || this.controller !== controller) return;
        let anyInStock = false;
        let allKnown = true;
        this.querySelectorAll('[data-location-id]').forEach((row) => {
          const entries = nodes.map(node => node?.storeAvailability?.nodes.find(entry => entry.location.id.split('/').pop() === row.dataset.locationId));
          let quantity = null;
          if (nodes.length === this.memberIds.length && entries.every(entry => entry && Number.isInteger(entry.quantityAvailable))) {
            if (this.dataset.grouped === 'true') {
              const offset = this.basis?.offsets?.[row.dataset.locationId];
              if (this.basis?.version === 1 && Number.isInteger(offset)) quantity = entries.reduce((sum, entry) => sum + entry.quantityAvailable, offset);
            } else { quantity = entries[0].quantityAvailable; }
          }
          let state = 'unknown';
          let label = this.text.unknown;
          if (quantity !== null) {
            if (quantity > 0) {
              state = 'in-stock'; label = this.text.inStock; anyInStock = true;
            } else if (!(this.dataset.knownLocations || '').split(',').includes(row.dataset.locationId)) {
              allKnown = false;
            } else if (this.dataset.policy === 'continue' || (this.dataset.grouped === 'true' && this.dataset.canOrder === 'true')) {
              state = 'orderable'; label = this.text.orderable;
            } else {
              state = 'out-of-stock'; label = this.text.outOfStock;
            }
          } else { allKnown = false; }
          row.dataset.state = state;
          row.querySelector('[data-stock-status]').textContent = label;
        });
        const canOrder = this.dataset.canOrder === 'true';
        this.querySelector('[data-stock-summary]').textContent = anyInStock ? this.text.inStock : (canOrder ? (allKnown ? this.text.orderableDelivery : this.text.orderableUnknown) : this.text.unavailable);
      } catch (error) {
        if (this.isConnected && this.controller === controller) this.renderUnknown();
      } finally {
        clearTimeout(timeout);
        if (this.isConnected && this.controller === controller) list.setAttribute('aria-busy', 'false');
      }
    }
  }
  customElements.define('location-stock', LocationStock);
})();
